export default __webpack_public_path__ + "static/media/logistics-manager-signature.a3c64918.png";